/**
 * Opens Growave's Wishlist flyout from the header heart.
 */
(function () {
  const TRIGGER_SELECTOR = '[data-wishlist-drawer-trigger], .gw-wl-icon';

  function openWishlistsDrawer() {
    const methods =
      window.gw && window.gw.sdk && window.gw.sdk.wishlists && window.gw.sdk.wishlists.methods;

    if (!methods || typeof methods.openWishlistsDrawer !== 'function') return false;
    methods.openWishlistsDrawer();
    return true;
  }

  function runWhenWishlistsReady(callback) {
    const invoke = function () {
      const moduleName = window.gw.sdk.common.constants.modules.WISHLISTS;
      window.gw.sdk.runIfModuleReady(moduleName, callback);
    };

    if (window.gw && window.gw.sdk) {
      invoke();
      return;
    }

    document.addEventListener('gwSdkReady', invoke, { once: true });
  }

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    if (openWishlistsDrawer()) return;
    runWhenWishlistsReady(openWishlistsDrawer);
  });
})();
